import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Navbar, TextInput, Button } from "../components/indexComponents";
import "../CSS/TaskDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXmark,
  faCheck,
  faEdit,
  faUpDownLeftRight,
  faArrowLeft,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

function TaskDetails() {
  const { id } = useParams();
  const { isTeam } = useParams();
  const isTeamBool = isTeam === "true";
  const [taskData, setTaskData] = useState(null);
  const [taskSteps, setTaskSteps] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showCompleted, setShowCompleted] = useState(true);
  const [firstFetch, setFirstFetch] = useState(true);

  /* #region  GET tous les infos de la tache */
  const fetchTask = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/tasks/${id}/${isTeam}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch task");
      }

      const data = await response.json();
      setTaskData(data);
      if (firstFetch) {
        const sortedSteps = data.steps.sort(
          (a, b) => a.completed - b.completed
        );
        setTaskSteps(sortedSteps);
        setFirstFetch(false);
      } else {
        setTaskSteps(data.steps);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching task:", error);
    }
  };
  useEffect(() => {
    fetchTask();
  }, []);
  /* #endregion */

  /* #region  Sauvegarder quels étapes est cocher  */
  const handleCheckboxChange = async (index, isChecked) => {
    let updatedSteps = [...taskSteps]; // Créer une copie des étapes

    updatedSteps[index].completed = isChecked; // Mettre à jour la propriété "completed" de l'étape correspondante

    updateSteps(updatedSteps);

    if (isChecked) {
      updateStepDone(1);
    } else {
      updateStepDone(-1);
    }
  };

  const updateStepDone = async (value) => {
    console.log("fefefeffefe", taskData.teamId);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/step-update`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            value: value,
            isTeam,
            teamId: taskData.teamId,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch teams");
      }
    } catch (error) {
      console.error("Error updating step done:", error);
    }
  };
  /* #endregion */

  /* #region  Ajouter des nouvelles étapes */
  const [stepsToAdd, setStepsToAdd] = useState([]);

  const handleStepChange = (index, event) => {
    const newSteps = [...stepsToAdd];
    newSteps[index] = { content: event.target.value, completed: false };
    setStepsToAdd(newSteps);
  };

  const addStep = () => {
    setStepsToAdd([...stepsToAdd, { content: "", completed: false }]);
  };

  const handleSaveNewSteps = () => {
    const newSteps = [...stepsToAdd, ...taskSteps];
    updateSteps(newSteps);
    setStepsToAdd([]);
  };

  /* #endregion */

  /* #region  Supprimer un étape */
  const indexToDelete = (index) => {
    const updatedSteps = [...taskSteps];
    updatedSteps.splice(index, 1);
    updateSteps(updatedSteps);
  };

  const handleWhichToDelete = (index) => {
    const updatedDelete = [...confirmDelete];
    updatedDelete[index] = updatedDelete[index] ? false : true;
    setConfirmDelete(updatedDelete);
  };
  /* #endregion */

  /* #region  Modifier une étape */
  const [editedStepIndex, setEditedStepIndex] = useState(null);
  const [editedStepValue, setEditedStepValue] = useState("");
  const [editName, setEditName] = useState("");
  const [isChangingName, setIsChangingName] = useState(false);

  const handleEditStep = (index) => {
    setEditedStepIndex(index);
    setEditedStepValue(taskSteps[index].content);
  };

  const handleEditedStepChange = (event) => {
    setEditedStepValue(event.target.value);
  };

  const handleNameEdit = () => {
    setIsChangingName(!isChangingName);
    setEditName(taskData.name);
  };
  const handleNameChange = (event) => {
    setEditName(event.target.value);
  };
  const handleChangedName = async () => {
    await updateSteps(taskSteps, editName);
    setIsChangingName(!isChangingName);
  };

  const handleSaveEditedStep = () => {
    const updatedSteps = [...taskSteps];
    updatedSteps[editedStepIndex] = {
      ...updatedSteps[editedStepIndex],
      content: editedStepValue,
    };
    updateSteps(updatedSteps);
    setEditedStepIndex(null);
    setEditedStepValue("");
  };

  const handleCancelEditStep = () => {
    setEditedStepIndex(null);
    setEditedStepValue("");
  };
  /* #endregion */

  /* #region  Actualisé les étapes de la tache */
  const updateSteps = async (newSteps, name) => {
    try {
      const newName = name ? name : taskData.name;
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/tasks/${id}/${isTeam}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({
            name: newName,
            clientId: taskData.clientId,
            steps: newSteps.map((step) => ({
              content: step.content,
              completed: step.completed,
            })),
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update task");
      }

      const updatedTask = await response.json();
      if (Array.isArray(updatedTask.steps)) {
        setTaskSteps(updatedTask.steps);
      } else {
        console.error("Error: updatedTask.steps is not an array");
      }
      setStepsToAdd([]);
      fetchTask();
    } catch (error) {
      console.error("Error updating task:", error);
    }
  };
  /* #endregion */

  return (
    <div id="TaskDetails" className="page-frame">
      <Navbar />
      <div className="TaskDetails-content page-content">
        {taskData ? (
          <Button
            icon={faArrowLeft}
            route={
              isTeamBool ? `/team-tasks/${taskData.teamId}` : `/active-tasks`
            }
            className="back-btn"
          />
        ) : (
          ""
        )}

        {!isLoading ? (
          <>
            <div className="heading-taskDetail">
              {isTeamBool ? (
                <p className="assignTo">
                  Assigné à{" "}
                  {taskData.assignTo[0].includes("Tous les membres")
                    ? "Tous les membres"
                    : taskData.assignTo.join(" ")}
                </p>
              ) : null}

              {isChangingName ? (
                <>
                  <input
                    type="text"
                    className="edit-name-input"
                    value={editName}
                    onChange={handleNameChange}
                  />
                  <button onClick={handleChangedName}>Sauvegarder</button>
                </>
              ) : (
                <h1 onClick={handleNameEdit}>{taskData.name}</h1>
              )}

              <h2>
                {isTeamBool ? taskData.Team_Client.name : taskData.Client.name}
              </h2>
              <button
                onClick={() => setShowCompleted(!showCompleted)}
                className="show-step-btn"
              >
                {showCompleted ? "Cacher" : "Afficher"} les étapes terminées
              </button>
            </div>

            <button type="button" onClick={addStep} className="add-step-btn">
              <FontAwesomeIcon icon={faPlus} /> Ajouter un étape
            </button>
            {stepsToAdd.map((step, index) => (
              <div key={index}>
                <TextInput
                  labelText={`Étape ${index + 1} :`}
                  type="text"
                  value={step.content}
                  onChange={(e) => handleStepChange(index, e)}
                />
              </div>
            ))}
            {stepsToAdd.length > 0 ? (
              <button type="button" onClick={addStep} className="add-step-btn">
                <FontAwesomeIcon icon={faPlus} />
              </button>
            ) : (
              ""
            )}

            {stepsToAdd.length >= 1 ? (
              <div className="edit-save-btn-container">
                <button type="button" onClick={handleSaveNewSteps}>
                  Sauvegarder
                </button>
                <button type="button" onClick={(e) => setStepsToAdd([])}>
                  Annuler
                </button>
              </div>
            ) : (
              ""
            )}
            <ul>
              <DragDropContext
                onDragEnd={(param) => {
                  const srcI = param.source.index;
                  const desI = param.destination.index;
                  taskSteps.splice(desI, 0, taskSteps.splice(srcI, 1)[0]);
                  updateSteps(taskSteps);
                }}
              >
                <Droppable droppableId="droppable-1">
                  {(provided, _) => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      {taskSteps
                        .filter((step) => showCompleted || !step.completed)
                        .map((step, index) => (
                          <Draggable
                            key={step.index}
                            draggableId={"draggable-" + index}
                            index={index}
                          >
                            {(provided, snapshot) => (
                              <li
                                key={index}
                                className={`task-step ${
                                  step.completed ? "completed" : ""
                                }`}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  boxShadow: snapshot.isDragging
                                    ? "0 0 .6rem #666"
                                    : "3px 2px 5px 2px rgba(161, 161, 161, 0.103)",
                                  background: snapshot.isDragging ? "#fff" : "",
                                }}
                              >
                                <div className="btn-container">
                                  <div {...provided.dragHandleProps}>
                                    <FontAwesomeIcon
                                      icon={faUpDownLeftRight}
                                      className="dragable-icon"
                                    />
                                  </div>
                                  <input
                                    className="task-details__checkbox"
                                    type="checkbox"
                                    checked={step.completed}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        index,
                                        e.target.checked
                                      )
                                    }
                                  />
                                </div>
                                {editedStepIndex === index ? (
                                  <div className="textarea-edit">
                                    <textarea
                                      className="edit-input"
                                      type="text"
                                      value={editedStepValue}
                                      onChange={handleEditedStepChange}
                                    />
                                  </div>
                                ) : (
                                  <p className="step-value">{step.content}</p>
                                )}
                                {confirmDelete[index] ? (
                                  <div className="confirm-delete-step">
                                    Supprimer l'étape ?
                                    <button
                                      className="btn-confirmer-etape"
                                      onClick={(e) => indexToDelete(index)}
                                    >
                                      <FontAwesomeIcon icon={faCheck} />
                                    </button>
                                    <button
                                      className="btn-supprimer-etape"
                                      onClick={(e) =>
                                        handleWhichToDelete(index)
                                      }
                                    >
                                      <FontAwesomeIcon icon={faXmark} />
                                    </button>
                                  </div>
                                ) : (
                                  <div className="edit-btn-container">
                                    {editedStepIndex === index ? (
                                      <div className="edit-save-btn-container">
                                        <button
                                          type="button"
                                          onClick={handleSaveEditedStep}
                                        >
                                          <FontAwesomeIcon icon={faCheck} />
                                        </button>
                                        <button
                                          type="button"
                                          onClick={handleCancelEditStep}
                                        >
                                          <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                      </div>
                                    ) : (
                                      <>
                                        <button
                                          className="btn-edit-step"
                                          onClick={() => handleEditStep(index)}
                                        >
                                          <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button
                                          className="btn-supprimer-etape"
                                          onClick={(e) =>
                                            handleWhichToDelete(index)
                                          }
                                        >
                                          <FontAwesomeIcon icon={faXmark} />
                                        </button>
                                      </>
                                    )}
                                  </div>
                                )}
                              </li>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </ul>
          </>
        ) : (
          <>
            <div>
              <h1>Chargement de la tâche...</h1>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
export default TaskDetails;
